/** @jsx jsx */
import { Dialog } from '@datacamp/waffles/dialog';
import { Paragraph } from '@datacamp/waffles/paragraph';
import { jsx } from '@emotion/react';
import React from 'react';

import iconsTopRightPng from '../../assets/images/icons_top_right.png';
import List from '../List';

import GuidesBackButton from './GuidesBackButton';

const ReferenceMaterialModal: React.FC = () => {
  return (
    <>
      <Dialog.Header>Accessing the reference material</Dialog.Header>
      <Dialog.Body>
        <Paragraph>
          You can easily rewatch the previous video, take another look at the
          pdf slides when working on an exercise, or report a problem. In the
          top right corner you will find three icons that can help you with
          this.
        </Paragraph>
        <List>
          <List.Item>
            The first icon will open a pop-up window in which you can watch the
            demo video related to the exercise you are trying to solve. This can
            be handy when you forgot how to perform a certain action in the BI
            software.
          </List.Item>
          <List.Item>
            The second icon will open a pop-up window in which you can see the
            PDF version of the slides. This can be handy when you want to look
            up a concept that was introduced in the previous video.
          </List.Item>
          <List.Item>
            The last icon allows you to provide feedback about the exercise. If
            something isn’t working properly, or you spot a mistake, you can
            report that to Datacamp here. We will do our best to address the
            issue as soon as possible.
          </List.Item>
        </List>
        <img
          alt="icon top right"
          height="auto"
          src={iconsTopRightPng}
          style={{ marginTop: 16 }}
          width="100%"
        />
      </Dialog.Body>
      <Dialog.Footer>
        <GuidesBackButton />
      </Dialog.Footer>
    </>
  );
};

export default ReferenceMaterialModal;
